import { Box } from "@mui/material";
import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import CaseStudyBanner from "../../assets/images/CaseStudyBanner.png";

const CaseStudyDetailBgLandingPage = () => {
  return (
    <Box
      sx={{
        width: "100%",
        paddingTop: "5rem",
      }}
    >
      <Box
        sx={{
          margin: { xs: "2rem 1.2rem 1.2rem 1.2rem", sm: "4rem" },
          height: { xs: "100%", sm: "30rem" },
        }}
      >
        <LazyLoadImage
          src={CaseStudyBanner}
          effect="blur"
          width="100%"
          height="100%"
          style={{
            objectFit: "cover",
          }}
        />
      </Box>
    </Box>
  );
};

export default CaseStudyDetailBgLandingPage;
